import styled from 'styled-components';
import { MediaThumbnailLabel } from '@frameio/vapor';
import { LabelReveal, useAssetState } from '../../../../states';
import TEXT from './generated/TEXT/InteractiveLabel';

export const InteractiveLabel = ({
  isInteractiveEligible,
  isInteractive,
  isWeb,
}: {
  isInteractiveEligible?: boolean | null;
  isInteractive?: boolean;
  isWeb?: boolean;
}) => {
  const assetState = useAssetState();

  return (
    <StyledLabelWrapper>
      <StyledLabelReveal
        visible={isInteractiveEligible === true && assetState === 'complete'}
      >
        <MediaThumbnailLabel>{TEXT.containsHTML}</MediaThumbnailLabel>
      </StyledLabelReveal>
      <StyledLabelReveal visible={isInteractive === true}>
        <MediaThumbnailLabel>{TEXT.interactive}</MediaThumbnailLabel>
      </StyledLabelReveal>
      <StyledLabelReveal visible={isWeb === true}>
        <MediaThumbnailLabel>{TEXT.web}</MediaThumbnailLabel>
      </StyledLabelReveal>
    </StyledLabelWrapper>
  );
};

TEXT.DEFINE({
  /** Media-type chip shown on a thumbnail for an interactive-eligible asset */
  containsHTML: 'Contains HTML',
  /** Media-type chip shown on a thumbnail for an interactive asset */
  interactive: 'Interactive',
  /** Media-type chip shown on a thumbnail for a live web URL asset */
  web: 'Web',
});

const StyledLabelWrapper = styled.div`
  position: relative;
`;

const StyledLabelReveal = styled(LabelReveal)`
  bottom: 0;
  position: absolute;
  right: 0;
  white-space: nowrap;
`;
